<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0">
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">JUB-YAM Admin</h4>
                </div>
                <div class="card-body">
                  <!-- <form role="form"> -->
                    <div class="mb-3">
                      <input type="text" class="form-control" placeholder="Username"  size="lg" v-model="this.username"/>
                    </div>
                    <div class="mb-3">
                      <input type="password" class="form-control" placeholder="Password"  size="lg" v-model="this.password"/>
                    </div>
                    <argon-switch id="rememberMe">Remember me</argon-switch>

                    <div class="text-center">
                      <argon-button
                        class="mt-4"
                        variant="gradient"
                        color="success"
                        fullWidth
                        size="lg"
                        @click="login()"
                      >LOGIN </argon-button>
                    </div>
                  <!-- </form> -->
                </div> 
  
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="background-image: url('https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg');
          background-size: cover;"
              >
                <span class="mask bg-gradient-success opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >"เพราะช่วงเวลาที่สำคัญของชีวิต เราเลือกผิดไม่ได้ ..."</h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
/* eslint-disable */
import ArgonInput from "@/components/ArgonInput.vue";
import ArgonSwitch from "@/components/ArgonSwitch.vue";
import ArgonButton from "@/components/ArgonButton.vue";
import axios from 'axios'
const qs = require('querystring')
const body = document.getElementsByTagName("body")[0];
var host_api=window.localStorage.getItem('$host_api');

// var username = 'abc'
// var password = '1234'

export default {
  name: "signin",
  components: {
    ArgonInput,
    ArgonSwitch,
    ArgonButton,
  },
  data() {
    return {
      // username : "ckt",
      // password : "jy4554",
      username : "",
      password : ""
    }
  },

  created() {

    this.$store.state.hideConfigButton = true;
    this.$store.state.showNavbar = false;
    this.$store.state.showSidenav = false;
    this.$store.state.showFooter = false;
    body.classList.remove("bg-gray-100");
  },
  beforeUnmount() {
    this.$store.state.hideConfigButton = false;
    this.$store.state.showNavbar = true;
    this.$store.state.showSidenav = true;
    this.$store.state.showFooter = true;
    body.classList.add("bg-gray-100");
  },

  methods :{ 
    login(){           
      host_api=window.localStorage.getItem('$host_api');
      const config = {
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      }

      const requestBody = {
          username: this.username,
          password: this.password
      }

    //   axios.post(host_api+"/admin/login_admin", qs.stringify(requestBody), config,
      axios.post(process.env.VUE_APP_Login, qs.stringify(requestBody), config,
        ).then(response => {
            if (response.data.result == "success") {
              this.$store.state.memo = response.data.t1;
              this.$router.push({
                name: 'user',
                // params : { 
                //   memo : response.data.t1,
                //   // user : response.data.user,
                //   type : "extra"
                // }
              })
              localStorage.setItem('$logged_user','admin')
            } else if (response.data.result == "influ") {
              // this.$router.push('/referral_extra')
              localStorage.setItem('$logged_user','extra')
              localStorage.setItem('$memo', JSON.stringify(response.data.t1))
              this.$store.state.memo = response.data.t1;
              this.$store.state.user = response.data.user;
              this.$store.state.type = "extra";
              this.$router.push({
                name: 'ReferralExtra',
                params : { 
                  memo : response.data.t1,
                  user : response.data.user,
                  type : "extra"
                
                }
              })
            } else if (response.data.result == "normal") {
              localStorage.setItem('$logged_user','extra')
              this.$store.state.memo = response.data.t1;
              this.$store.state.user = response.data.user;
              this.$store.state.type = "normal";
              this.$router.push({
                name: 'ReferralExtra',
                params : { 
                  memo : response.data.t1,
                  user : response.data.user,
                  type : "normal"
                }
              })
            }
            else {
                console.log("False")
            }
        })
    }
  }
};
</script>
